import { create } from 'zustand';
import { ChatUserType } from '../types';

interface IState {
	user: ChatUserType | null;
	setChatUser: (user: ChatUserType | null) => void;
}

export const useChatUserStore = create<IState>(set => ({
	user: null,
	setChatUser: user =>
		set(() => ({
			user,
		})),
}));
